module.exports = __webpack_public_path__ + "static/media/IMG_0315_Reduced.f3d29683.jpg";